import React from "react"
import { config } from "@fortawesome/fontawesome-svg-core";
import Navigation from "../components/navigation"

config.autoAddCss = false;

const Layout = ({ location, title, children }) => {
  return (
    <div>
      <Navigation />
      <main>{children}</main>
      <footer id="footer">
        <p>Invently Ltd is a limited company registered in England and Wales. Registered number: 10929292. | <a href="/cookies">Cookies</a></p>
      </footer>
    </div>
  )
}

export default Layout
